import React from 'react';
import { desktopBallad, TextLink } from '@spotify-internal/encore-web-v6';
import styled from 'styled-components';

import { Link } from '../../../ui';

export const StyledLink = styled(TextLink)`
  opacity: 75%;
  text-decoration: none;
  ${() => desktopBallad}
  &:hover {
    color: currentColor !important;
    text-decoration: none !important;
    opacity: 100% !important;
  }
`;

type LinkProps = {
  track: [string, string, string?]; // category/label for GA tracking - category ignored for external
  href: string;
  prefetch?: boolean; // same as NextJS link
  external?: boolean; // external link opens new window, etc.
};

export type LinkType = LinkProps & { label: string; dataTestId: string };

export const FooterNavLink = ({ link }: { link: LinkType }) => {
  return (
    <Link {...link}>
      <StyledLink semanticColor="textBase" data-testId={link.dataTestId}>
        {link.label}
      </StyledLink>
    </Link>
  );
};
